<template>
  <div class="row">
    <div
      class="col-12 col-xl-4"
      :class="[{ 'order-0': pictureLeft, 'order-1': !pictureLeft }, { 'text-end': !pictureLeft }]"
    >
      <div v-if="data.image" class="position-relative">
        <img :src="data.image.src" :style="data.image.style" alt="descriptive"/>
        <img v-if="data.image.mask" class="background d-none d-xl-block" :style="data.image.mask.style" :src="data.image.mask.src" alt="background mask"/>
      </div>
      <div v-if="data.linkBox" class="mt-3 px-3 pb-3 no-gutters" :class="getLinkBoxBackground()">
        <text-block :content-id="getIdPrefix() + 'LinkBox'" v-on:save="save" :content="data.linkBox"/>
      </div>
    </div>
    <div class="col-12 col-lg-8" :class="pictureLeft ? 'order-1' : 'order-0'">
      <text-block :content-id="getIdPrefix() + 'Text1'" v-on:save="save" :content="data.text1"/>
      <collapse-list v-if="data.expandable" :page="data.page" :content-id="getIdPrefix()" :list="data.expandable"/>
      <text-block class="mt-3" :content-id="getIdPrefix() + 'Text2'" v-on:save="save" :content="data.text2"/>
    </div>
  </div>
</template>

<style lang="scss">
#link-container {
  background: var(--p-color-white-50);
}

.collapsed > div > .opened,
:not(.collapsed) > div > .closed {
  display: none;
}

.background {
  z-index: -1;
}

.link-box-background-white {
  background: var(--p-color-white-0);
  border-radius: 24px;
}

.link-box-background-blue {
  background: var(--p-color-blue-600);
  border-radius: 24px;
}

.link-box-background-gray {
  background: var(--p-color-white-50);
  border-radius: 24px;
}
</style>
<script setup>
import TextBlock from "@/views/components/TextBlock.vue";

import collapseList from "@/views/components/collapseList.vue";
import {toRefs} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {usePageContent} from "@/mixins/pageContentMixin2";

const axios = injectAxios();
const props = defineProps([
  "pictureLeft",
  "data",
  "linkBoxVariant",
  "title",

]);
const { pictureLeft, data, linkBoxVariant, title, white, blue } = toRefs(props);
const { savePageContent } = usePageContent();
const { t, locale } = useI18n();

function getIdPrefix(){
  return data.value.element;
}

function getLinkBoxBackground() {
  switch (linkBoxVariant.value) {
    case "white":
      return "link-box-background-white";
    case "blue":
      return "link-box-background-blue";
    default:
      return "link-box-background-gray";
  }
}
const save = (elem) => {
  savePageContent(
    axios,
    data.value.page,
    locale.value,
    elem.element,
    elem.value,
  );
};
</script>
